import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Property, RentalTag } from "../../types";
import { Plus } from "lucide-react";
import AddSubPropertyForm from "../property/add-sub-property/form";
import { useState } from "react";
import { useReadonlyContext } from "@/modules/common/context/read-only.context";
import { PROPERTY_TRACKS } from "../../utils";

export default function AddSubProperty({
  property,
  hasLabel = true,
  trackTypeName,
}: Readonly<{
  property: Property;
  hasLabel?: boolean;
  trackTypeName?: string;
}>) {
  const [modalOpen, setModalOpen] = useState(false);
  const [rentalTagPromptOpen, setRentalTagPromptOpen] = useState(false);

  const { readonly } = useReadonlyContext();

  const rentalTag = property.propertyFinishing?.rentalTag;
  const isFinishingTrack = trackTypeName === PROPERTY_TRACKS.FINISHING;

  const handleButtonClick = () => {
    if (isFinishingTrack && !rentalTag) {
      setRentalTagPromptOpen(true);
    } else {
      setModalOpen(true);
    }
  };

  return (
    <>
      <Button
        disabled={readonly}
        variant="contained"
        sx={(theme) => ({
          display: "flex",
          gap: theme.nawy.spacing.xs,
          alignItems: "center",
          backgroundColor: theme.nawy.colors.semantic.layer.accent,
          ...(!hasLabel && {
            minWidth: 36,
            minHeight: 36,
            padding: 0,
          }),
        })}
        onClick={handleButtonClick}
      >
        {hasLabel ? (
          <Typography
            sx={(theme) => ({
              ...theme.nawy.typography.english.variants.body.md.semibold,
              textTransform: "none",
            })}
          >
            Add sub-property
          </Typography>
        ) : (
          <Plus size={16} />
        )}
      </Button>

      <Dialog
        open={rentalTagPromptOpen}
        onClose={() => setRentalTagPromptOpen(false)}
      >
        <DialogTitle>Rental Tag Required</DialogTitle>
        <DialogContent>
          <Typography>
            Please select a rental tag in the Financial Info section before
            adding a sub-property.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRentalTagPromptOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <AddSubPropertyForm
        propertyUid={property.uid}
        compound={property.compound}
        latitude={property.latitude}
        longitude={property.longitude}
        address={property.address}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        rentalTag={rentalTag as RentalTag | undefined}
        isFinishingTrack={isFinishingTrack}
      />
    </>
  );
}
